import { useSeo } from "@/hooks/useSeo";
import Breadcrumb from "@/components/base/Breadcrumb";
import Reveal from "@/components/base/Reveal";
import { siteInfo } from "@/mocks/site";

const positions = [
  {
    icon: "ri-megaphone-line",
    title: "官方信息发布",
    desc: "发布影视动态、音乐发行、活动公告与公益行动等官方资讯，确保信息来源清晰、更新及时。",
  },
  {
    icon: "ri-book-2-line",
    title: "作品完整展示",
    desc: "按类型与年份整理电影、电视剧、音乐与纪录片档案，呈现封面、简介与演职人员信息。",
  },
  {
    icon: "ri-team-line",
    title: "粉丝交流平台",
    desc: "提供作品讨论、活动招募与应援创意等话题空间，让粉丝与关注者可以持续交流与分享。",
  },
];

const facts = [
  { label: "公开作品档案", value: "9+" },
  { label: "影音类型覆盖", value: "4 类" },
  { label: "粉丝话题", value: "6 个" },
  { label: "官方栏目", value: "6 个" },
];

export default function AboutPage() {
  useSeo({
    title: "关于风间由美 - 风间由美官方网站",
    description:
      "了解风间由美：演员与歌手，持续在影视与音乐领域探索。本页介绍她的个人经历、官方网站定位，以及版权与免责声明。",
    keywords: "关于风间由美,风间由美简介,风间由美个人资料,官方网站定位",
  });

  return (
    <div className="mx-auto w-full max-w-[1320px] px-4 py-10 md:px-6 md:py-14">
      <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "关于风间由美" }]} />

      <header className="mt-6 border-b border-background-200 pb-8">
        <span className="text-xs font-medium tracking-[0.32em] text-primary-600">
          {siteInfo.brandEn} OFFICIAL
        </span>
        <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          关于风间由美
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {siteInfo.aboutIntro}
        </p>
      </header>

      <section className="mt-10 grid gap-10 lg:grid-cols-12 lg:gap-12">
        <Reveal className="lg:col-span-5">
          <div className="overflow-hidden rounded-lg border border-background-200" style={{ height: 520 }}>
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20portrait%20style%20scene%20with%20soft%20warm%20window%20light%20and%20minimal%20cream%20backdrop%2C%20abstract%20editorial%20fashion%20photography%2C%20refined%20orange%20and%20beige%20palette%2C%20soft%20shadows%2C%20high%20detail&width=880&height=1100&seq=about-portrait&orientation=portrait"
              alt="风间由美官方形象示意图"
              title="风间由美 - 官方形象"
              className="h-full w-full object-top"
            />
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            个人简介与官方网站定位
          </h2>
          <div className="mt-5 space-y-5">
            {siteInfo.aboutParagraphs.map((p, i) => (
              <p key={i} className="text-sm leading-loose text-foreground-700 md:text-base">
                {p}
              </p>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {facts.map((fact) => (
              <div
                key={fact.label}
                className="rounded-lg border border-background-200 bg-background-100/70 p-4 text-center"
              >
                <p className="font-heading text-2xl font-bold text-primary-600">{fact.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{fact.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mt-14">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          官方网站的定位
        </h2>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
          {positions.map((item, i) => (
            <Reveal key={item.title} delay={i * 80}>
              <div className="h-full rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mt-14 rounded-lg border border-background-200 bg-secondary-800 p-6 md:p-8">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-background-50">
          <i className="ri-shield-check-line text-accent-300" />
          版权声明与免责声明
        </h2>
        <div className="mt-4 space-y-3 text-sm leading-loose text-background-300">
          <p>
            本网站由风间由美工作室运营，站内文字、图片与编排内容仅用于官方资讯展示与粉丝交流，未经授权请勿用于商业用途。
          </p>
          <p>{siteInfo.disclaimer}</p>
        </div>
      </section>
    </div>
  );
}